export default __webpack_public_path__ + "static/media/no-result.e4a110e5.png";